import OrderHistoryContainer from './OrderHistoryContainer';

export default OrderHistoryContainer;
